import { Capacitor } from '@capacitor/core';
import { KEYBOARD_OPEN_CLASS } from '../styles/keyboard';

// Keyboard taller than this (px) counts as open in mobile browsers.
const MIN_KEYBOARD_HEIGHT = 150;

const setKeyboardOpen = (open) =>
  document.body.classList.toggle(KEYBOARD_OPEN_CLASS, open);

// Toggles body.keyboard-open while the on-screen keyboard is visible, so fixed
// bottom bars (see hideWhenKeyboardOpen) can hide instead of covering inputs.
export async function watchKeyboard() {
  if (Capacitor.isNativePlatform()) {
    const { Keyboard } = await import('@capacitor/keyboard');
    Keyboard.addListener('keyboardWillShow', () => setKeyboardOpen(true));
    Keyboard.addListener('keyboardWillHide', () => setKeyboardOpen(false));
    return;
  }

  // Mobile browsers shrink the visual viewport when the keyboard opens.
  // Multiplying by scale keeps pinch-zoom from reading as an open keyboard.
  const viewport = window.visualViewport;
  if (!viewport) return;
  const update = () =>
    setKeyboardOpen(
      window.innerHeight - viewport.height * viewport.scale > MIN_KEYBOARD_HEIGHT,
    );
  viewport.addEventListener('resize', update);
}
